import { render, staticRenderFns } from "./FixtureComponent.vue?vue&type=template&id=5896c8c8&"
import script from "./FixtureComponent.vue?vue&type=script&lang=js&"
export * from "./FixtureComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports